import { Button, Form } from "reactstrap";
import useAxios from "../../../../Utils/useAxios";
import { InputField } from "../../../../CommonElements";
import createStatusStaf from "../services/createStatusStaf";
import updateStatusStaf from "../services/updateStatusStaf";
import { Controller, useForm } from "react-hook-form";

const StatusStafForm = ({ resetState, toggle, data }) => {
  const { control, handleSubmit } = useForm({ defaultValues: data });
  const axiosInstance = useAxios();

  const createUserRole = (data) => {
    createStatusStaf(axiosInstance, data).then(() => {
      resetState();
      toggle();
    });
  };

  const editUserRole = (data) => {
    updateStatusStaf(axiosInstance, data.id_status_staf, data).then(() => {
      resetState();
      toggle();
    });
  };

  return (
    <Form
      onSubmit={
        data ? handleSubmit(editUserRole) : handleSubmit(createUserRole)
      }
    >
      <Controller
        name="nama_status_staf"
        control={control}
        rules={{
          required: "Harap masukkan nama status staf",
          // maxLength: {
          //   value: 10,
          //   message: "Nama status staf lebih dari 10 huruf",
          // },
        }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Status Staf"}
            defaultValue={data?.nama_status_staf}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default StatusStafForm;
